import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  onClick,
  type = 'button',
  className = '',
  disabled = false,
  as: Component = 'button',
  ...props
}) => {
  const baseStyles = 'font-semibold rounded-full transition-colors duration-300 inline-flex items-center justify-center';
  
  const variants = {
    primary: `text-white ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    secondary: `bg-white text-gray-900 hover:bg-gray-100 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    outline: `border-2 border-pink-700 text-pink-700 hover:bg-pink-700 hover:text-white ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`
  };

  const sizes = {
    small: 'py-2 px-6 text-sm min-h-[40px]',
    medium: 'py-3 px-8 text-base min-h-[48px]',
    large: 'py-4 px-10 text-lg min-h-[56px]'
  };

  const buttonClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;

  const elementProps = Component === 'button' ? { type, disabled } : {};

  const inlineStyles = variant === 'primary' ? {
    backgroundColor: '#db0058',
    ...props.style
  } : props.style;

  const handleMouseEnter = (e) => {
    if (variant === 'primary') {
      e.target.style.backgroundColor = '#b8004a';
    }
  };

  const handleMouseLeave = (e) => {
    if (variant === 'primary') {
      e.target.style.backgroundColor = '#db0058';
    }
  };

  return (
    <Component
      className={buttonClasses}
      style={inlineStyles}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      {...elementProps}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Button;